import React from 'react';
import { useTranslation } from 'react-i18next';
import { CheckBox, DefaultText, FlexRow } from '@guryou/html-components';
const workingDays = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

const WorkingDays = () => {
  const { t } = useTranslation();
  return (
    <>
      <DefaultText fontWeight={800}>{t('SESSIONS.includeDays')}</DefaultText>
      <FlexRow padding={0} margin={0}>
        {workingDays.map((day, index) => (
          <CheckBox
            label={t(`DAYS.${day}`)}
            labelPlacement="bottom"
            key={day}
            value={(index + 1) % 7}
            checked={index < 5 ? true : false}
            color="default"
            name={`workingDays`}
            margin={0}
            xs={1.7}
          />
        ))}
      </FlexRow>
    </>
  );
};

export default WorkingDays;
